import { useState } from "react";

import type { Session, SessionApi } from "../lib/api";
import { FileTree } from "./FileTree";
import { SearchPanel } from "./SearchPanel";
import { SessionPanel } from "./SessionPanel";

type Mode = "files" | "search";

interface Props {
  api: SessionApi;
  session: Session;
  onSession: (s: Session) => void;
  unsaved: number;
  activePath: string | null;
  refreshToken: number;
  onOpen: (path: string, line?: number) => void;
  onError: (message: string) => void;
}

export function Sidebar({
  api,
  session,
  onSession,
  unsaved,
  activePath,
  refreshToken,
  onOpen,
  onError,
}: Props) {
  const [mode, setMode] = useState<Mode>("files");

  return (
    <nav className="sidebar" aria-label="Workspace">
      <div className="sidebar-tabs" role="tablist">
        {(["files", "search"] as Mode[]).map((m) => (
          <button
            key={m}
            role="tab"
            className="sidebar-tab"
            aria-selected={mode === m}
            onClick={() => setMode(m)}
          >
            {m === "files" ? "Explorer" : "Search"}
          </button>
        ))}
      </div>
      {mode === "files" ? (
        <FileTree
          api={api}
          activePath={activePath}
          refreshToken={refreshToken}
          onOpen={onOpen}
          onError={onError}
        />
      ) : (
        <SearchPanel api={api} onOpen={onOpen} />
      )}
      <SessionPanel api={api} session={session} onSession={onSession} unsaved={unsaved} />
    </nav>
  );
}
